// import "bootstrap-css-only/css/bootstrap.min.css";
// import "mdbvue/lib/mdbvue.css";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import vuetify from "./plugins/vuetify";

// import VueApexCharts from "vue-apexcharts";
Vue.config.devtools = true;
Vue.config.productionTip = false;

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// install rules
Object.keys(rules).forEach(rule => {
  // @ts-ignore
  extend(rule, rules[rule]);
});

Vue.use(BootstrapVue);

Vue.use(vuetify);
Vue.use(IconsPlugin);

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
// Vue.component('apexchart', VueApexCharts);

new Vue({
  router,
  store,
  // @ts-ignore
  vuetify,
  render: h => h(App)
}).$mount("#app");
